"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableRow = _interopRequireDefault(require("../TableRow"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _idGenerator = _interopRequireDefault(require("../../../../utils/idGenerator"));

var _formatters = require("../../../../helpers/formatters");

var _Table = require("./Table.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Table = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Table, _React$PureComponent);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "buildTableRows", function () {
      var _this$props = _this.props,
          tableContent = _this$props.tableContent,
          omitTitleBar = _this$props.omitTitleBar;
      return tableContent.map(function (content, index) {
        var prevError = !!(index && tableContent[index - 1].errors && tableContent[index - 1].errors.length);
        var currentError = !!(content.errors && content.errors.length);
        var titleBar = !index && !omitTitleBar;
        return /*#__PURE__*/_react.default.createElement(_TableRow.default, {
          titleBar: titleBar,
          content: content,
          key: (0, _idGenerator.default)(),
          prevError: prevError,
          currentError: currentError
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "findErrors", function () {
      var tableContent = _this.props.tableContent;
      var errorMessages = tableContent.reduce(function (msgs, rowContent) {
        if (!rowContent.errors || !rowContent.errors.length) {
          return msgs;
        }

        return [].concat(_toConsumableArray(msgs), _toConsumableArray(rowContent.errors));
      }, []);
      return _toConsumableArray(new Set(errorMessages));
    });

    _defineProperty(_assertThisInitialized(_this), "buildErrorMessages", function (errors) {
      return errors.map(function (msg) {
        return /*#__PURE__*/_react.default.createElement(_Table.TableErrorMessage, {
          className: "c-table-error-message",
          key: "error-message-".concat((0, _formatters.toKabobCase)(msg))
        }, msg);
      });
    });

    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          dataTestId = _this$props2.dataTestId;
      var errors = this.findErrors();
      return /*#__PURE__*/_react.default.createElement(_Table.StyledTable, {
        "data-test-id": dataTestId,
        className: className
      }, /*#__PURE__*/_react.default.createElement(_Table.TableRowsContainer, {
        className: "c-table-rows-container"
      }, this.buildTableRows()), errors.length > 0 && /*#__PURE__*/_react.default.createElement(_Table.TableErrorBlock, {
        className: "c-table-error-block"
      }, /*#__PURE__*/_react.default.createElement(_Table.TableErrorIconContainer, {
        className: "c-table-error-icon-container"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        colorTheme: "danger",
        dataTestId: "table-error-icon",
        iconName: "exclamation-triangle"
      })), /*#__PURE__*/_react.default.createElement(_Table.TableErrorMessageWrapper, {
        className: "c-table-error-message-wrapper"
      }, this.buildErrorMessages(errors))));
    }
  }]);

  return Table;
}(_react.default.PureComponent);

_defineProperty(Table, "propTypes", {
  /** Class Override */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Content to fill table and title rows */

  /**
   * The element in the array will label each column in the title bar.
   * Subsequent array elements will be inserted into table rows.
   *
   * Each element in this array will contain an object. At a minimum this
   * object must contain the following:
   *    * rowContent: An array of content for the row in question. Each index
   *      can be in the form of a string that will be displayed as standard content
   *      OR an object with the following keys:
   *        * content: The large text content that will be displayed in the cell
   *        * label: Smaller text that will be displayed under the content
   *
   * Each of these row content elements also accept optional fields:
   *     * basis: [number: [with in percentage]]
   *        default: auto
   *        use: sets the flex-basis property, wich will affect width
   *     * align: [string: [left | center \ right]]
   *        default: center
   *        use: aligns text within the cell
   *     * isBold: [boolean]
   *        default: false
   *        use: sets text to bold weight on cell
   *
   * Additionally options can be set in the row object:
   *    * isBold: [boolean]
   *        default: false
   *        use: sets text to bold weight on row (overwrites cell preferences)
   *    * align: [string: [left | center \ right]]
   *        default: center
   *        use: aligns text within the cell (overwrites cell preferences)
   *
   * For example:
   *
   * [
   *   {
   *     rowContent: [
   *       {
   *         content: "I will be big text"
   *         label: "I will be small text underneath my buddy here ^^",
   *         align: "left"
   *       },
   *       {
   *         content: "I will be wider than normal, but look like normal content text",
   *         basis: 50
   *       }
   *       "I'm just normal content",
   *     ]
   *     isBold: true,
   *   }
   * ]
   */
  tableContent: _propTypes.default.arrayOf(_propTypes.default.shape({
    errors: _propTypes.default.arrayOf(_propTypes.default.string),
    rowContent: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape({
      content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
      label: _propTypes.default.string,
      basis: _propTypes.default.number
    }), _propTypes.default.string, _propTypes.default.node])),
    isBold: _propTypes.default.bool
  })).isRequired,
  omitTitleBar: _propTypes.default.bool
});

_defineProperty(Table, "defaultProps", {
  className: '',
  omitTitleBar: false
});

var _default = Table;
exports.default = _default;